export default function genderPatner(partner) {
    if (partner.gender === 'Female') {
        return 'Ate';
    } else {
        return 'Kuya';
    }
}